'use strict';

var buildEnhancedMapping = require('../internal/buildEnhancedMapping');
module.exports = buildEnhancedMapping('map');